/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_SubtitleInputs */

const en_contact_form_subtitle = /** @type {(inputs: Contact_Form_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two fields. Add as much or as little as you like.`)
};

const lv_contact_form_subtitle = /** @type {(inputs: Contact_Form_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divi lauki. Aprakstiet situāciju tik īsi vai plaši, cik vēlaties.`)
};

/**
* | output |
* | --- |
* | "Two fields. Add as much or as little as you like." |
*
* @param {Contact_Form_SubtitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_form_subtitle = /** @type {((inputs?: Contact_Form_SubtitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_SubtitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_form_subtitle(inputs)
	return en_contact_form_subtitle(inputs)
});